module.exports = __webpack_public_path__ + "media/delivered.37479005.mp3";